import React, { Fragment } from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { DatePicker, PercentInput, AutoCompleteInput, IntegerInput } from "components/Global/FormikMaterial";
import { interestRateRounding } from "../../Constants/DropDownLists";

const StyledDatePicker = styled(DatePicker)`
  & {
    width:100%;
    margin-top:-2px !important;
  }
`;

const StyledIntegerInput = styled(IntegerInput)`
  & {width:100%;}
`;

const StyledPercentInput = styled(PercentInput)`
  & {width:100%;}
`;
const StyledAutoCompleteInput = styled(AutoCompleteInput)`
  & {
    width:100%;
  }
`;
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;

const YieldMaintenanceTraditionalFields = () => (
  <>
    <Grid item xs={6}>
      <StyledDatePicker
        label={<StyledLabel>{"Prepayment Date"}</StyledLabel>}
        fieldName="prepaymentDate"
      />

      </Grid>
      <Grid item xs={6}>
        <StyledIntegerInput
          label={<StyledLabel>{"Open Periods"}</StyledLabel>}
          fieldName="openPeriods" />
      </Grid>
      <Grid item xs={6}>
        <StyledPercentInput
          label={<StyledLabel>{"Minimum Penalty (%)"}</StyledLabel>}
          decimalScale={3}
          fieldName="minimumPenalty"
          allowNegative={false} />
      </Grid>
      <Grid item xs={6}>
        <StyledIntegerInput
          label={<StyledLabel>{"Replacement Rate Lookback"}</StyledLabel>}
          fieldName="lookbackDays" />
      </Grid>
      <Grid item xs={6}>
        <StyledAutoCompleteInput
          label={<StyledLabel>{"Replacement Rate Rounding"}</StyledLabel>}

        fieldName="interestRateRounding"
        selectValue="value"
        options={interestRateRounding}
      />
    </Grid>
  </>
);
export default YieldMaintenanceTraditionalFields;
